import { SVGProps } from 'react';
import { lighten } from 'polished';

interface EmptyStateDoneProps extends SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  color?: string;
}

const EmptyStateDone = ({ width = 250, height = 200, color = '#4e7184', className, ...rest }: EmptyStateDoneProps) => {
  const accent = lighten(0.1, color);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 250 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['empty-state-svg', className].filter(Boolean).join(' ')}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56 127C56 130.866 59.134 134 63 134H154C154.515 134 155.017 133.944 155.5 133.839C155.983 133.944 156.485 134 157 134H209C212.866 134 216 130.866 216 127C216 123.134 212.866 120 209 120H203C199.134 120 196 116.866 196 113C196 109.134 199.134 106 203 106H222C225.866 106 229 102.866 229 99C229 95.134 225.866 92 222 92H200C203.866 92 207 88.866 207 85C207 81.134 203.866 78 200 78H136C139.866 78 143 74.866 143 71C143 67.134 139.866 64 136 64H79C75.134 64 72 67.134 72 71C72 74.866 75.134 78 79 78H39C35.134 78 32 81.134 32 85C32 88.866 35.134 92 39 92H64C67.866 92 71 95.134 71 99C71 102.866 67.866 106 64 106H24C20.134 106 17 109.134 17 113C17 116.866 20.134 120 24 120H63C59.134 120 56 123.134 56 127ZM226 134C229.866 134 233 130.866 233 127C233 123.134 229.866 120 226 120C222.134 120 219 123.134 219 127C219 130.866 222.134 134 226 134Z"
        fill={color + '33'}
      />
      <path d="M172.5 45V51" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M172.5 59V65" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M162.5 55H168.5" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M176.5 55H182.5" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M89.5 148V152" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M89.5 160V164" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M81.5 156H85.5" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M93.5 156H97.5" stroke={accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.711 131.126C162.102 129.423 163.352 127.642 164.461 125.799C166.901 121.744 168.66 117.388 169.734 112.897C170.821 108.356 171.209 103.676 170.894 99.0296C170.62 94.9756 169.811 90.9475 168.465 87.0598C167.131 83.2028 165.268 79.484 162.875 76.015C161.45 73.9479 159.836 71.9696 158.034 70.1036C155.388 67.364 152.486 65.0219 149.402 63.0787C146.089 60.9908 142.566 59.3634 138.926 58.1984C134.368 56.7393 129.628 56.0054 124.886 56C121.197 55.9959 117.507 56.4328 113.902 57.3125C109.845 58.3028 105.895 59.8543 102.177 61.9692C98.9076 63.8284 95.817 66.123 92.988 68.8547C89.4328 72.2875 86.553 76.1572 84.3512 80.2985C82.1956 84.3532 80.6899 88.6682 79.8366 93.0887C78.9574 97.6429 78.7706 102.309 79.2789 106.918C79.9378 112.891 81.7643 118.768 84.7644 124.179C86.684 127.641 89.0842 130.912 91.9663 133.896C96.5416 138.634 101.883 142.183 107.604 144.535C114.562 147.397 122.081 148.489 129.465 147.8C135.662 147.221 141.765 145.387 147.361 142.29"
        fill="white"
      />
      <path
        d="M160.711 131.126C162.102 129.423 163.352 127.642 164.461 125.799C166.901 121.744 168.66 117.388 169.734 112.897C170.821 108.356 171.209 103.676 170.894 99.0296C170.62 94.9756 169.811 90.9475 168.465 87.0598C167.131 83.2028 165.268 79.484 162.875 76.015C161.45 73.9479 159.836 71.9696 158.034 70.1036C155.388 67.364 152.486 65.0219 149.402 63.0787C146.089 60.9908 142.566 59.3634 138.926 58.1984C134.368 56.7393 129.628 56.0054 124.886 56C121.197 55.9959 117.507 56.4328 113.902 57.3125C109.845 58.3028 105.895 59.8543 102.177 61.9692C98.9076 63.8284 95.817 66.123 92.988 68.8547C89.4328 72.2875 86.553 76.1572 84.3512 80.2985C82.1956 84.3532 80.6899 88.6682 79.8366 93.0887C78.9574 97.6429 78.7706 102.309 79.2789 106.918C79.9378 112.891 81.7643 118.768 84.7644 124.179C86.684 127.641 89.0842 130.912 91.9663 133.896C96.5416 138.634 101.883 142.183 107.604 144.535C114.562 147.397 122.081 148.489 129.465 147.8C135.662 147.221 141.765 145.387 147.361 142.29"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M150.701 140.378C153.607 138.508 156.191 136.175 157.872 134.291Z" fill="white" />
      <path d="M150.701 140.378C153.607 138.508 156.191 136.175 157.872 134.291" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <path
        d="M166.14 104.625C140.886 104.625 120.209 84.9362 118.476 60C98.3752 63.1706 83 80.6526 83 101.743C83 125.081 101.825 144 125.048 144C147.309 144 165.53 126.615 167 104.617C166.714 104.622 166.427 104.625 166.14 104.625Z"
        fill={color + '1A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.785 100.567C103.668 101.803 103.753 103.721 104.977 104.851L119.096 117.889C120.808 119.47 123.465 119.349 125.029 117.618C125.095 117.544 125.095 117.544 125.158 117.469L145.307 92.9716C146.366 91.6837 146.192 89.7716 144.918 88.7008C143.644 87.63 141.752 87.806 140.693 89.0939L121.75 112.125L109.023 100.373C107.8 99.2433 105.903 99.33 104.785 100.567Z"
        fill="white"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.824 64.4131C108.874 65.1448 106.969 66.0338 105.128 67.0806C102.269 68.7073 99.5648 70.7149 97.0898 73.1049C96.0753 74.0846 95.1237 75.105 94.235 76.1611"
        fill="white"
      />
      <path
        d="M110.824 64.4131C108.874 65.1448 106.969 66.0338 105.128 67.0806C102.269 68.7073 99.5648 70.7149 97.0898 73.1049C96.0753 74.0846 95.1237 75.105 94.235 76.1611"
        stroke={accent}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.485 79.8379C90.7783 80.9057 90.128 82.0004 89.5341 83.1177C89.0954 83.9429 88.6875 84.7804 88.3104 85.6285"
        fill="white"
      />
      <path
        d="M91.485 79.8379C90.7783 80.9057 90.128 82.0004 89.5341 83.1177C89.0954 83.9429 88.6875 84.7804 88.3104 85.6285"
        stroke={accent}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default EmptyStateDone;
